module.exports = __webpack_public_path__ + "img/product3.f884ad45.png";